export const changeOfRegDetailsSchema = {
  title: 'Change of Reg Details',
  type: 'object',
  properties: {
    changeType: {
      type: 'string',
      title: 'Change Type',
      enum: [
        'AddressChange',
        'DomIndicatorChange',
        'ConsentGranularityChange',
        'IHDStatusChange',
        'SMSOChange',
        'RelatedMPANAdd',
        'RelatedMPANCreate',
        'RelatedMPANRemove',
        'LinkedMPANAdd',
        'LinkedMPANCreate',
        'LinkedMPANRemove',
        'SSCandProfileClass',
      ],
      enumNames: [
        'Address Change',
        'Dom Indicator Change',
        'Consent Granularity Change',
        'IHD Status Change',
        'SMSO Change',
        'Related MPAN Add',
        'Related MPAN Create',
        'Related MPAN Remove',
        'Linked MPAN Add',
        'Linked MPAN Create',
        'Linked MPAN Remove',
        'SSC and Profile Class',
      ],
    },
    mpan_core: {
      type: 'string',
      title: 'MPAN',
    },
  },
  required: ['changeType', 'mpan_core'],
  dependencies: {
    changeType: {
      oneOf: [
        {
          properties: {
            changeType: { enum: ['AddressChange'] },
            postcode: {
              type: 'string',
              title: 'Postcode',
            },
            address_line_1: {
              type: 'string',
              title: 'Address Line 1',
            },
            address_line_2: {
              type: 'string',
              title: 'Address Line 2',
            },
            address_line_3: {
              type: 'string',
              title: 'Address Line 3',
            },
            address_line_4: {
              type: 'string',
              title: 'Address Line 4',
            },
            address_line_5: {
              type: 'string',
              title: 'Address Line 5',
            },
            address_line_6: {
              type: 'string',
              title: 'Address Line 6',
            },
            address_line_7: {
              type: 'string',
              title: 'Address Line 7',
            },
            address_line_8: {
              type: 'string',
              title: 'Address Line 8',
            },
            address_line_9: {
              type: 'string',
              title: 'Address Line 9',
            },
          },
          required: ['postcode', 'address_line_1'],
        },
        {
          properties: {
            changeType: { enum: ['DomIndicatorChange'] },
            is_dom_indicator: {
              type: 'boolean',
              title: 'Is Dom Indicator',
              default: false,
            },
          },
          required: ['is_dom_indicator'],
        },
        {
          properties: {
            changeType: { enum: ['ConsentGranularityChange'] },
            consent_granularity: {
              type: 'string',
              title: 'Consent Granularity',
              enum: ['H', 'D', 'M', 'N'],
              enumNames: ['Hourly', 'Daily', 'Monthly', 'None'],
            },
            consent_granularity_efd: {
              type: 'string',
              title: 'Consent Granularity EFD',
              format: 'date',
            },
          },
          required: ['consent_granularity', 'consent_granularity_efd'],
        },
        {
          properties: {
            changeType: { enum: ['IHDStatusChange'] },
            ihd_install_status: {
              type: 'string',
              title: 'IHD Install Status',
              enum: ['I', 'D', 'E', 'F'],
              enumNames: ['Installed', 'Declined', 'Exchange', 'Faulty'],
            },
            ihd_install_status_efd: {
              type: 'string',
              title: 'IHD Install Status EFD',
              format: 'date',
            },
          },
          required: ['ihd_install_status', 'ihd_install_status_efd'],
        },
        {
          properties: {
            changeType: { enum: ['SMSOChange'] },
            smso: {
              type: 'string',
              title: 'SMSO',
            },
            smso_efd: {
              type: 'string',
              title: 'SMSO EFD',
              format: 'date',
            },
          },
          required: ['smso', 'smso_efd'],
        },
        {
          properties: {
            changeType: { enum: ['RelatedMPANAdd', 'RelatedMPANCreate', 'RelatedMPANRemove'] },
            related_mpan_secondary: {
              type: 'string',
              title: 'Related MPAN Secondary',
            },
          },
          required: ['related_mpan_secondary'],
        },
        {
          properties: {
            changeType: { enum: ['LinkedMPANAdd', 'LinkedMPANCreate', 'LinkedMPANRemove'] },
            linked_mpan_import_export: {
              type: 'string',
              title: 'Linked MPAN Import/Export',
            },
          },
          required: ['linked_mpan_import_export'],
        },
        {
          properties: {
            changeType: { enum: ['SSCandProfileClass'] },
            ssc: {
              type: 'string',
              title: 'SSC',
            },
            ssc_efd: {
              type: 'string',
              title: 'SSC EFD',
            },
            pc: {
              type: 'string',
              title: 'Profile Class',
              enum: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
              enumNames: [
                '0 - Non-domestic HH / Half-hourly supply (import and export)',
                '1 - Domestic Unrestricted',
                '2 - Domestic Economy 7',
                '3 - Non-domestic Unrestricted',
                '4 - Non-domestic Economy 7',
                '5 - Non-domestic, MD, load factor 0-20%',
                '6 - Non-domestic, MD, load factor 20-30%',
                '7 - Non-domestic, MD, load factor 30-40%',
                '8 - Non-domestic, MD, load factor 40%+',
              ],
            },
            pc_efd: {
              type: 'string',
              title: 'Profile Class EFD',
            },
          },
        },
      ],
    },
  },
};

export const changeOfRegDetailsUISchema = {
  changeType: {
    'ui:widget': 'select',
    'ui:placeholder': 'Select Change Type',
  },
  mpan_core: {
    'ui:widget': 'MpanSearchWidget',
    'ui:placeholder': 'Select MPAN',
  },
  consent_granularity: {
    'ui:widget': 'select',
    'ui:placeholder': 'Select Consent Granularity',
  },
  consent_granularity_efd: {},
  ihd_install_status: {
    'ui:widget': 'select',
    'ui:placeholder': 'Select IHD Install Status',
  },
  ihd_install_status_efd: {},
  smso_efd: {},
  ssc: {
    'ui:placeholder': 'Select SSC',
  },
  ssc_efd: {},
  pc: {
    'ui:widget': 'select',
    'ui:placeholder': 'Select Profile Class',
  },
  pc_efd: {},
  'ui:order': [
    'changeType',
    'mpan_core',
    'postcode',
    'address_line_1',
    'address_line_2',
    'address_line_3',
    'address_line_4',
    'address_line_5',
    'address_line_6',
    'address_line_7',
    'address_line_8',
    'address_line_9',
    'is_dom_indicator',
    'consent_granularity',
    'consent_granularity_efd',
    'ihd_install_status',
    'ihd_install_status_efd',
    'smso',
    'smso_efd',
    'related_mpan_secondary',
    'linked_mpan_import_export',
    'ssc',
    'ssc_efd',
    'pc',
    'pc_efd',
  ],
};
